import { render, staticRenderFns } from "./OrderShortShip.vue?vue&type=template&id=be336544"
import script from "./OrderShortShip.vue?vue&type=script&lang=js"
export * from "./OrderShortShip.vue?vue&type=script&lang=js"
import style0 from "./OrderShortShip.vue?vue&type=style&index=0&id=be336544&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports